module.exports = __webpack_public_path__ + "media/src/images/logos/partners/ficci-f63a0ef03921b024015245be8e511172.svg";